var React = require('react');

function ChevronRightLarge (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L20 24L1 47","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronRightLarge.defaultProps = {"width":"21","height":"48","viewBox":"0 0 21 48","fill":"none"};

module.exports = ChevronRightLarge;

ChevronRightLarge.default = ChevronRightLarge;
